/*------------------------------------*\
    MODULES
\*------------------------------------*/
// import $ from "jquery";

/*------------------------------------*\
    LANGUAGE SWITCH
\*------------------------------------*/
class LanguageSwitch {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        var toggle = document.getElementById('langToggle');
        var listItems = document.getElementsByClassName('language-switch__list__item');

        toggle.addEventListener('click', evt => {
            self.toggleDropdown();
        });

        for (let i of listItems) {
            i.addEventListener('click', evt => {
                self.reloadPage();
            });
        };
    }

    toggleDropdown() {
        let self = this;

        var toggle = document.getElementById('langToggle');
        var dropdown = document.getElementById('langDropdown');

        toggle.classList.toggle('active');
        dropdown.classList.toggle('active');
    }

    reloadPage() {
        console.log('reload');
    }
}

export default LanguageSwitch;
